import { DrawdownInvestmentStrategyClient } from "../../../../../../../../Wrap/Api/Account/DrawdownInvestmentStrategy";
import { PensionArrangementClient } from "../../../../../../../../Wrap/Api/Account/PensionArrangement";
import { PensionArrangementValuationsClient } from "../../../../../../../../Wrap/Api/Account/PensionArrangementValuations";
import { DrawdownInvestmentStrategy } from "../../../../../../../../Wrap/Models/Domains/Account/DrawdownInvestmentStrategy";
import { PensionArrangement } from "../../../../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { PensionArrangementValuation } from "../../../../../../../../Wrap/Models/Models/Account/PensionArrangementValuation";

export class PensionArrangementAction {
    public static GetPensionArrangementValuation(hierarchyIds: string[], shouldAdjustRoundingForDisplay: boolean, callback: (data: PensionArrangementValuation[]) => void) {
        const client = new PensionArrangementValuationsClient();
        const promise = client.get(hierarchyIds, shouldAdjustRoundingForDisplay);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }

    public static GetPensionArrangementDetails(hierarchyId: string, includeClosed: boolean, callback: (data: PensionArrangement[]) => void) {
        const client = new PensionArrangementClient();
        const promise = client.get(hierarchyId, includeClosed);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }

    public static GetDrawdownInvestmentStrategy(hierarchyId: string, callback: (data: DrawdownInvestmentStrategy) => void) {
        const client = new DrawdownInvestmentStrategyClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }
}